import { FC } from 'react';
import * as S from './OverlayMenus.style';
import LayersMenu from './parts/LayersMenu/LayersMenu';
import CulturesMenu from './parts/CulturesMenu/CulturesMenu';
import TransportsMenu from './parts/TransportsMenu/TransportsMenu';
import { MapMenuType } from '../../slice/types';
import SelectFieldsByCultureMenu from './parts/SelectFieldsByCultureMenu/SelectFieldsByCultureMenu';

interface IProps {
  activeMapMenu: MapMenuType;
}

const OverlayMenus: FC<IProps> = ({ activeMapMenu }) => {
  return (
    <S.MenuArea>
      {activeMapMenu === 'FIELD_SELECT_BY_CULTURE' && (
        <SelectFieldsByCultureMenu />
      )}

      {activeMapMenu === 'TRANSPORT' && <TransportsMenu />}

      {activeMapMenu === 'LAYER' && <LayersMenu />}

      {activeMapMenu === 'CULTURE' && <CulturesMenu />}
    </S.MenuArea>
  );
};

export default OverlayMenus;
